module.exports = __webpack_public_path__ + "static/media/Cognigy.9a130b4c.svg";